export default {
  configure: 'Configurar',
  chat: 'Chat',
  transferToAgent: 'Transferência para um agente',
  clickToHelpPerson: 'Essa pessoa precisa de ajuda clique para ajudá-lo',
  openConversation: 'Conversa aberta',
  conversations: 'Conversas',
  noPendingConversations: 'Não há conversas pendentes',
  lastMessage: 'Última mensagem',
  channel: 'Canal',
  yourConversations: 'Suas conversas',
  closedConversations: 'Conversas fechadas',
  allConversations: 'Todas as conversas',
  finishConversation: 'Terminar a conversa',
  closeChat: 'Fechar o bate-papo',
  loadingMessages: 'Carregando mensagens',
  noMessagesFound: 'Não há nenhuma mensagem',
  conversationAlreadyTaken: 'Conversa já tomada',
  toWrite: 'Escrever',
  toHelp: 'Ajuda',
  attendConversation: 'Assista à conversa',
  quickResponses: 'Respostas rápidas',
  writeMessage: 'Escrever mensagem',
  conversationFinishedByAdvisor: 'Conversa concluída pelo conselheiro',
  finishedConversation: 'Conversa concluída',
  conversationTakenByAdvisor: 'Conversa tomada pelo conselheiro',
  updatedConversation: 'Conversa atualizada',
  configureChat: 'Configurar o chat',
  loadingConversations: 'Carregando conversas',
  waitingForAdvisor: 'Esperando por conselheiro',
  finished: 'Terminou',
  takenByMe: 'Levado por mim',
  takenByAdvisor: 'Tomada por {advisor}',
  withAdvisor: 'Com conselheiro',
  registered: 'A pessoa ainda não escreveu.',
  canIHelpYouWithSomething: 'Posso te ajudar com alguma coisa?',
  attachInWebSite: 'Anexar no site',
  authenticationType: 'Tipo de autenticação',
  noAuthentication: 'Sem autenticação',
  externalAuthentication: 'Autenticação externa',
  form: 'Forma',
  city: 'Cidade',
  appearance: 'Aparência',
  light: 'Luz',
  dark: 'Escuro',
  mainColor: 'Cor principal',
  pickAMainColor: 'Escolha uma cor principal',
  reestablishColor: 'Restabelecer a cor',
  backgroundColor: 'Cor de fundo',
  pickABackgroundColor: 'Escolha uma cor de fundo',
  customLogo: 'Logotipo personalizado',
  customTitle: 'Título personalizado',
  customBubbleMessage: 'Mensagem de bolha personalizada',
  showEmojis: 'Mostrar emojis',
  customQuestions: 'Perguntas personalizadas',
  insertChatQuestions: 'Digite as perguntas que você deseja mostrar no bate-papo',
  permanentMessages: 'Mensagens permanentes',
  insertFirstChatMessages: 'Digite as mensagens que você deseja aparecer como primeira mensagem de bate-papo',
  reasonsOfFinishedConversation: 'Razões da conversa terminada',
  possibleReasonsAdvisorEndConversation: 'Digite as principais razões pelas quais um conselheiro pode terminar uma conversa',
  insertQuickResponsesForAdvisors: 'Digite as respostas rápidas que os conselheiros terão disponíveis',
  inactivityMessage: 'Mensagem de intutividade',
  enableInactivityMessage: 'Habilitar mensagem de inatividade',
  insertInactivityMessage: 'Digite a mensagem de inatividade',
  timeForTriggeringInactivityMessage: 'Tempo em segundos para desencadear uma mensagem de inatividade',
  attentionSchedule: 'Horário de atenção',
  outOfServiceMessage: 'Mensagem fora de serviço',
  customFormMessage: 'Mensagem de formulário personalizada',
  nonWorkingDay: 'Dia de não-trabalho',
  allDay: 'O dia todo',
  noOpening: 'Sem abertura',
  noClosing: 'Sem encerramento',
  advisors: 'Conselheiros',
  assignConversationsAutomaticallyToConnectedAdvisors: 'Atribua conversas automaticamente a conselheiros conectados',
  pickAdvisors: 'Escolha conselheiros',
  monday: 'Segunda-feira',
  tuesday: 'Terça',
  wednesday: 'Quarta',
  thursday: 'Quinta',
  friday: 'Sexta',
  saturday: 'Sábado',
  sunday: 'Domingo',
  configurationSavedSuccessfully: 'Configurações salvas com sucesso',
  insertChatInYourWebSite: 'Insira o chat no site yor',
  instructionsForInsertingChat: 'Para adicionar o chat em seu site você deve adicionar o próximo script no rodapé do seu site',
  copiedScript: 'Roteiro copiado',
  errorCopyingScript: 'Erro copiando o script',
  noMessage: 'Sem mensagem',
  toTransfer: 'Transferência',
  agentSuccessfullyTransferred: 'Agente transferido com sucesso',
  youAreDeclaringNoWorkingDay: 'Você está declarando este dia como dia de não-trabalho',
  opening: 'Abertura',
  closing: 'Fechar',
  establishAgentsForSelfAllocationOfConversations: 'Estabelecer agentes para auto-alocação de conversas',
  assignConversations: 'Atribuir conversas',
  ready: 'Pronto',
  advisorUpdated: 'Orientador atualizado',
  errorPrecessingRequest: 'Ocorreu um erro ao processar a solicitação',
  periodStatistics: 'Estatísticas de período',
  noStatsFoundForThisDateRange: 'Não foram encontradas estatísticas para esta faixa de data',
  forEachDayHowMuchWasTheAverageTimePerConversation: 'Para cada dia quanto era o tempo médio por conversa?',
  forEachAdvisorHowMuchWasTheAverageTimePerConversation: 'Para cada conselheiro quanto foi o tempo médio por conversa?',
  statsPerDay: 'Estatísticas por dia',
  noStatsFoundForThisDay: 'Nenhuma estatística encontrada para este dia',
  usersCreated: 'Usuários criados',
  attendedConversations: 'Conversas Assistidas',
  noAttendedConversations: 'Conversas sem resposta',
  attendedAndUnansweredConversations: 'Conversas atendidas e não atendidas',
  attended: 'Participou',
  averageTimeBeforeTheAdvisorTookControl: 'Tempo médio antes do conselheiro assumir o controle',
  averageTimeSinceTheAdvisorTookControl: 'Tempo médio desde que o conselheiro assume o controle',
  howManyWereAttended: 'Quantos foram atendidos?',
  conversationsNumber: 'Número de conversas',
  howManyConversationsDidEachAdvisorAttended: 'Quantas conversas cada conselheiro participou?',
  numberConversationsAttended: 'Número de conversas atendidas',
  howManyUsersWereCreated: 'Quantos usuários foram criados?',
  users: 'Usuários',
  howLongWasTheAverageTimePerConversation: 'Quanto tempo foi o tempo médio por conversa?',
  minutes: 'Minutos',
  whatWereTheTopicsOfTheConversations: 'Quais foram os tópicos das conversas',
  numberOfRepetitions: 'Número de repetições',
  howManyConversationsWereAttendedForEachHour: 'Quantas conversas foram assistidas por hora?',
  howManyConversationsDidEachAdvisorHavePerHour: 'Quantas conversas cada conselheiro teve por hora?',
  howManyUsersWereCreatedPerHour: 'Quantos usuários foram criados por hora?',
  advisor: 'Conselheiro',
  tellUsWhoYouAre: 'Diga-nos quem você é.',
  selectTheInformationYouWantToAskPeople: ' Selecione as informações que deseja perguntar às pessoas',
  startConversation: 'Iniciar conversa',
  emptyMessage: 'Mensagem vazia',
  blockMessageComposer: 'Compositor de mensagens em bloco',
  timeZone: 'Fuso Horário',
  addSchedule: 'Adicionar Horário',
  checkTheServiceHours: 'Confira o horário de funcionamento',
  newKeybeConversation: 'Nova conversa de Keybe',
  details: 'Detalhes',
  enterName: 'Digite o nome',
  enterEmail: 'Digite e-mail',
  enterPhone: 'Digite telefone',
  enterCountry: 'Entre no país',
  country: 'País',
  enter: 'Entrar',
  enterValue: 'Digite o valor',
  selectPerson: 'Selecione uma pessoa',
  anonymousPerson: 'Essa pessoa é anônima.',
  personDetails: 'Dados da pessoa',
  newApplication: 'Nova Aplicação',
  channels: 'Canais',
  authentication: 'Autenticação',
  finalization: 'Conclusão',
  customizeYourConversation: 'Personalize a sua conversa',
  schedules: 'Horários',
  assignment: 'Atribuição',
  correctlyEmailConnection: 'O seu correio foi conectado com sucesso',
  correctlyEmailDisconnection: 'O seu correio foi desconectado com sucesso',
  administratorsOnly: 'Apenas Administradores',
  setTheEndTimeForConversations: 'Defina o tempo para a conclusão das conversas',
  automaticallyEndUnansweredConversations: 'Terminar automaticamente as conversas que deixaram de ser respondidas',
  definesTheTimeUserStopsResponding: 'Define o tempo para terminar a conversa assim que o usuário parar de responder',
  finishAfter: 'Terminar depois de',
  enterTheReasonForAutomaticCompletion: 'Digite o motivo da conclusão automática',
  position: 'Posição',
  defaultLanguage: 'Idioma predefinido',
  tagsAsAMethodOfAutoAssignment: 'Etiquetas como método de auto-atribuição',
  enterTags: 'Digite as Tags',
  updateTags: 'Tags de atualização',
  communicationChannels: 'Canais de Comunicação',
  youMustPreviouslyGrantKeybeGooglePermission: 'Você deve dar à Keybe permissões para acessar sua Conta do Google com antecedência',
  connectWithGoogle: 'Conecte-se ao Google',
  youHaveCurrentlyAuthorizedKeybe: 'Você autorizou a Keybe a acessar sua conta no momento',
  andYouHaveCorrectlyConfiguredGmail: 'e você configurou com sucesso o Gmail',
  disconnectFromGmail: 'Desconectando-se do Gmail',
  connectToGmail: 'Como se conectar ao Gmail',
  notificationPermissions: 'Você recusou as permissões para mostrar notificações. Verifique as informações do site na barra de endereço da web e permita que as notificações continuem recebendo alertas quando você receber uma mensagem',
  dontShowMessage: 'Não mostre esta mensagem novamente'
}
